// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ln-z","tupacHeader":"mn-z","tupacHeader2":"nn-z","tupacMenu":"on-z","tupacMenu2":"pn-z","tupacMain":"qn-z","tupacMain2":"rn-z"};